import { observable, action, runInAction } from 'mobx';
import { get, jsonPost } from '../../utils/fetch';
import { backendServerInvestor, backendServer } from '../../variable';
import { errorHandler } from '../../utils/methods';

class TodoStore {
  //申购详情下的两张table数据
  @observable
  purchaseObject = {
    total: 0,
    list: []
  };
  @observable
  ownerListObject = {
    total: 0,
    ownerList: []
  };
  //用户基本信息
  @observable
  userInfo = {
    userStatus: 0,
    projectName: '',
    enterpriseName: '',
    userId: '',
    purchaseNumber: '',
    contractPlantLegalInstrumentList: []
  };

  //获取申购详情申购记录列表
  @action
  fetchPurchaseList = async params => {
    let result;
    try {
      const url = params.projectId
        ? `${backendServerInvestor}/web/process/purchase/todo`
        : `${backendServerInvestor}/web/process/purchase/todo`;
      //: `${backendServerInvestor}/web/todo`;
      result = await get(url, params);
      runInAction(() => {
        if (result.success) {
          this.purchaseObject = result.data;
        } else {
          this.purchaseObject = {
            total: 0,
            list: []
          };
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };

  //获取申购详情持有人记录列表
  @action
  fetchOwnerList = async params => {
    let result;
    try {
      const url = `${backendServerInvestor}/web/process/purchase/hold`;
      result = await get(url, params);
      runInAction(() => {
        if (result.success) {
          this.ownerListObject = {
            total: result.data.total || 0,
            ownerList: result.data.list || []
          };
        } else {
          this.ownerListObject = {
            total: 0,
            ownerList: []
          };
        }
      });
    } catch (err) {
      return errorHandler(err, '查询申购详情持有人记录列表');
    }
    console.log('查询申购详情持有人记录列表', result);
    return result;
  };

  // 用户信息---待处理事项
  @action
  fetchUserInfo = async params => {
    let result;
    try {
      result = await get(`${backendServerInvestor}/web/todo/user`, params);
      runInAction(() => {
        if (result.success) {
          this.userInfo = result.data;
        }
      });
    } catch (err) {
      return errorHandler(err, '查询项目列表');
    }
    return result;
  };
}

const todoStore = new TodoStore();
export default todoStore;



// WEBPACK FOOTER //
// ./src/stores/todoStore/index.js